import React, {useCallback, useRef, useState} from 'react'
import {
  Layout,
  Page,
  Card,
  TextField,
  Checkbox,
  FormLayout,
  SkeletonBodyText,
  List,
  Link,
  FooterHelp, Button
} from '@shopify/polaris'
import { useDispatch, useSelector } from 'react-redux'

import { formatHTML } from '../../libs/utils'
import useShouldSendRequest from '../../hooks/useShouldSendRequest'
import {actionSetToastError, actionSetToastMessage, actionToggleToastActive} from "../../store/actions";

const SliderCodeComponent = (props) => {
  const dispatch = useDispatch()
  const editingId = props.match ? props.match.params.id : false
  const [hasPlaceholder, setHasPlaceholder] = useState(true)
  const activeItem = useSelector(state => state.activeItem)
  const app = useSelector(state => state.app)
  const codeArea = useRef(null)
  const shouldLoading = useShouldSendRequest(
    `/api/v2/admin/slider/${editingId}`,
    editingId && !Object.keys(activeItem).length
  )


  const copyToClipboard = useCallback((e) => {
    if (codeArea) {
      const textarea = codeArea.current.querySelector('textarea')
      if (textarea) {
        textarea.select()
        document.execCommand('copy')
        textarea.focus()
        dispatch(actionSetToastMessage('Code copied.'))
        dispatch(actionSetToastError(false))
        dispatch(actionToggleToastActive(true))
      }
    }
  }, [])

  const mapperCode = activeItem && Object.keys(activeItem).length ? `
    <div>
      <div
        id="image-mapper-slider-${editingId}"
        class="image-mapper image-mapper--slider"
        ${hasPlaceholder ? 'has-placeholder' : ''}
        data-mapper-module="mapper"
        data-mapper='{
          "url": "${app.appUrl}/api/v2/sliders/${editingId}"
        }'>
          ${hasPlaceholder ? `<img src="${activeItem.mappers.length > 0 ? activeItem.mappers[0].image_url : ''}" class="im-tmp" style="display:block;max-width:100%;">` : ''}
      </div>
    </div>` : <div/>
  return (
    <Page
      fullWidth
      breadcrumbs={[{
        content: 'Slider',
        url: '/sliders'
      }]}
      title='Slider code'
    >
      {shouldLoading && <SkeletonBodyText />}
      {!shouldLoading && <Layout>
        <Layout.Section oneHalf>
          <Card title="Code" sectioned>
            <FormLayout>
              {codeArea && <Button plain onClick={copyToClipboard}>Click here to copy code</Button>}
              <div ref={codeArea}>
                <TextField
                  readOnly
                  value={formatHTML(mapperCode)}
                  multiline={4}
                />
              </div>
              <Checkbox
                label='Show image placeholder instead of loading icon'
                checked={hasPlaceholder}
                onChange={setHasPlaceholder}
              />
            </FormLayout>
          </Card>
        </Layout.Section>
        <Layout.Section oneHalf>
          <Card title="FAQs" sectioned>
            <List type="bullet">
              <List.Item>
                <Link url="/docs#/faqs/how-to-add-a-mapperslider-to-a-homepage" external>How to add a mapper/slider to your homepage?</Link>
              </List.Item>
              <List.Item>
                <Link url="/docs#/faqs/how-to-add-a-mapperslider-to-a-page" external>How to add a mapper/slider to a page?</Link>
              </List.Item>
              <List.Item>
                <Link url="/docs#/faqs/how-to-add-a-mapperslider-to-a-blog-post" external>How to add a mapper/slider to a blog post?</Link>
              </List.Item>
              <List.Item>
                <Link url="/docs#/faqs/how-to-add-a-mapperslider-to-a-product" external>How to add a mapper/slider to a product page?</Link>
              </List.Item>
              <List.Item>
                <Link url="/docs#/faqs/how-to-add-a-mapperslider-to-a-collection" external>How to add a mapper/slider to a collection page?</Link>
              </List.Item>
            </List>
          </Card>
        </Layout.Section>
      </Layout>}
      <FooterHelp>
        Learn more about<Link url="/docs#/get-and-install-code" external> installing a slider</Link>
      </FooterHelp>
    </Page>
  )
}

export default SliderCodeComponent
